export const bargeDatabase = {
  SMALL_COASTAL: {
    name: "Small Coastal Shuttle",
    capacity: {
      bbl: 50000,
      metricTon: 7000,
      litres: 7950000
    }
  },

  MEDIUM_RANGE: {
    name: "Medium Range Crude Carrier",
    capacity: {
      bbl: 250000,
      metricTon: 35000,
      litres: 39700000
    }
  },

  LARGE_CRUDE: {
    name: "Large Crude Carrier",
    capacity: {
      bbl: 700000,
      metricTon: 98000,
      litres: 111300000
    }
  },

  VLCC: {
    name: "Very Large Crude Carrier (VLCC)",
    capacity: {
      bbl: 2000000,
      metricTon: 280000,
      litres: 318000000
    }
  }
};